<template>
  <div>
    <v-card
      :disabled="rental.submitted_offer == '1'"
      v-if="isSearch"
      elevation="10"
      class="disabled:opacity-10 shadow ma-4"
      color="grey lighten-4"
    >
      <!-- @click="singleView(rental) " -->
      <v-img
        :class="isFirm ? ' text-center' : ''"
        class="p-1"
        :aspect-ratio="16 / 9"
        :src="rental.image_url"
      >
        <span
          class="px-5 py-1.5 bg-opacity-75 text-xs  bg-gray-900 text-gray-100"
        >
          {{ rental.days_on_market }} Days on market
        </span>
      </v-img>

      <div v-if="!isFav" x-data="{ tooltip3: false }" class="float-right z-10">
        <span class="inline-flex items-center">
          <button
            @click="checkFavorite(rental.listingId)"
            x-on:mouseover="tooltip3 = true"
            x-on:mouseleave="tooltip3 = false"
            class="text-indigo-500 hover:text-indigo-600"
          >
            <i class="far fa-bookmark"></i>
          </button>

          <div
            class="absolute -ml-20 -mt-16 w-full"
            x-cloak
            x-show.transition.origin.top="tooltip3"
          >
            <div
              class="absolute px-2 text-sm text-indigo-900 bg-indigo-50 z-10 shadow rounded-lg hover:shadow-lg"
            >
              Mark as Favorite
            </div>
          </div>
        </span>
      </div>
      <div v-else class="float-right z-10">
        <span v-if="haveUser(user, rental)" class="inline-flex items-center">
          <button
            @click="unMarked(rental)"
            class="text-indigo-500 hover:text-indigo-600"
          >
            <i class="fas fa-bookmark"></i>
          </button>
        </span>
      </div>

      <v-card-text>
        <div class="font-weight-light grey--text title mb-2">
          <div class="float-right text-xl font-medium text-gray-600">
            ${{
              parseFloat(rental.price)
                .toLocaleString()
                .replace(".", ",")
            }}
          </div>

          <h3 class="text-lg font-weight-light blue--text">
            {{ rental.address }}
          </h3>
        </div>

        <v-divider></v-divider>
        <div class="text-center">
          <span class="m-1">
            <i class="mr-1 text-secondary fas fa-align-justify"></i>
            <b class="mr-1">Lot:</b>
            {{ rental.square_footage }}
          </span>

          <span class="m-1">
            <i class="mr-1 text-secondary fas fa-bath"></i>
            <b class="mr-1">Bathroom:</b>{{ rental.bathroom }}</span
          >

          <span class="m-1">
            <i class="mr-1 text-secondary fas fa-bed"></i>
            <b class="mr-1">Bedroom:</b>{{ rental.bedroom }}</span
          >
        </div>

        <v-divider></v-divider>

        <div class="m-2" v-if="markShown">
          <v-btn
            :disabled="rental.home_shown == 1"
            @click="markShownHome()"
            x-small
            color="success"
          >
            Mark as Shown <i class="ml-1 fas fa-check"></i
          ></v-btn>
          <v-btn
            v-if="rental.home_shown == 1"
            @click="cancelRequested()"
            class="ml-2"
            x-small
            color="error"
          >
            Cancel Shown
          </v-btn>
        </div>
        <template v-else>
          <div v-if="isFav" class="m-2 font-medium flex gap-2 text-center">
            <v-btn
              v-if="rental.request_showing"
              x-small
              :loading="canceling"
              @click="cancelShowing(rental)"
              color="error"
            >
              Cancel Showing <i class="ml-1 far fa-calendar-plus"></i
            ></v-btn>
            <v-btn
              v-else
              x-small
              :loading="valueLoading"
              @click="requestShowing(rental)"
              color="success"
            >
              Request Showing <i class="ml-1 far fa-calendar-plus"></i
            ></v-btn>
            <v-btn
              x-small
              @click="redirectListing(rental.listingId)"
              color="info"
            >
              Details <i class="ml-1 fas fa-external-link-alt"></i
            ></v-btn>
          </div>

          <div
            v-else-if="isShown"
            class="m-2 font-medium flex gap-2 text-center"
          >
            <v-btn
              :disabled="
                disabledButton ||
                  rental.disabled == '1' ||
                  rental.submitted_offer == '1'
              "
              x-small
              @click="submitOffer(rental)"
              :loading="disabledButton"
              color="success"
            >
              Submit Offer <i class="ml-1 far fa-calendar-plus"></i
            ></v-btn>
            <v-btn
              x-small
              @click="redirectListing(rental.listingId)"
              color="info"
            >
              Details <i class="ml-1 fas fa-external-link-alt"></i
            ></v-btn>
          </div>
          <div v-else class="text-left m-2 font-medium">
            <v-btn
              x-small
              @click="redirectListing(rental.listingId)"
              color="info"
            >
              Details <i class="ml-1 fas fa-external-link-alt"></i
            ></v-btn>
          </div>
        </template>
      </v-card-text>
    </v-card>

    <v-card
      v-else
      elevation="10"
      class="cursor-pointer shadow ma-2 sm:ma-4"
      color="grey lighten-4"
    >
      <!-- @click="singleView(rental) " -->
      <v-img
        :class="isFirm ? ' text-center' : ''"
        class="p-1"
        @click="showHouse(rental)"
        :aspect-ratio="16 / 9"
        :src="rental.Images[0]"
      >
        <span
          v-if="isFirm"
          class="px-5 py-1.5 bg-opacity-75 rounded-full text-base font-medium w-full bg-green-100 text-green-800"
        >
          Featured
        </span>

        <span
          v-else
          class="px-5 py-1.5 bg-opacity-75 text-xs  bg-gray-900 text-gray-100"
        >
          {{ rental.DaysOnMarket }} Days on market
        </span>
      </v-img>

      <div v-if="user" x-data="{ tooltip3: false }" class="float-right z-10">
        <span v-if="containUser(user, rental)" class="inline-flex items-center">
          <button
            @click="unMarkFavorite(rental)"
            x-on:mouseover="tooltip3 = true"
            x-on:mouseleave="tooltip3 = false"
            class="text-indigo-500 hover:text-indigo-600"
          >
            <i class="fas fa-bookmark"></i>
          </button>

          <div
            class="absolute -ml-20 -mt-16 w-full"
            x-cloak
            x-show.transition.origin.top="tooltip3"
          >
            <div
              class="absolute px-2 text-sm text-white bg-indigo-900 z-10 shadow rounded-lg hover:shadow-lg"
            >
              Marked as Favorite
            </div>
          </div>
        </span>

        <span v-else class="inline-flex items-center">
          <button
            @click="markFavorite(rental)"
            x-on:mouseover="tooltip3 = true"
            x-on:mouseleave="tooltip3 = false"
            class="text-indigo-500 hover:text-indigo-600"
          >
            <i class="far fa-bookmark"></i>
          </button>
          <!-- sm:-mt-0 sm:ml-4  -->
          <div
            class="absolute -ml-20 -mt-16 w-full"
            x-cloak
            x-show.transition.origin.top="tooltip3"
          >
            <div
              class="absolute px-2 text-sm text-indigo-900 bg-indigo-50 z-10 shadow rounded-lg hover:shadow-lg"
            >
              Mark as favorite
            </div>
          </div>
        </span>
      </div>

      <v-card-text>
        <div class="font-weight-light grey--text title mb-2">
          <div class="float-right text-xl font-medium text-gray-600">
            ${{
              parseFloat(rental.ListPrice)
                .toLocaleString()
                .replace(".", ",")
            }}
          </div>

          <h3 class="text-lg font-weight-light blue--text">
            {{ rental.StreetNumber }}
            {{ rental.StreetName }}
            {{ rental.StreetSuffix }}
          </h3>

          <h3 class="text-xs font-weight-light blue--text mb-2">
            {{ rental.City }}, {{ rental.StateOrProvince }}
            {{ rental.PostalCode }}
          </h3>
        </div>

        <v-divider></v-divider>
        <div class="text-center">
          <span class="m-1">
            <i class="mr-1 text-secondary fas fa-align-justify"></i>
            <b class="mr-1">Lot:</b>
            {{ rental.LotSizeAcresRange }}
          </span>

          <span class="m-1">
            <i class="mr-1 text-secondary fas fa-bath"></i>
            <b class="mr-1">Bathroom:</b>{{ rental.BathroomsFull }}</span
          ><br />

          <span class="m-1">
            <i class="mr-1 text-secondary fas fa-bed"></i>
            <b class="mr-1">Bedroom:</b>{{ rental.BedroomsTotal }}</span
          >

          <span class="m-1">
            <i class="mr-1 text-secondary fas fa-bed"></i>
            <b class="mr-1">Year Built:</b>{{ rental.YearBuilt }}</span
          >
        </div>
      </v-card-text>
    </v-card>

    <!-- :persistent="selectedRental ? false : true" -->
    <v-dialog
      transition="dialog-bottom-transition"
      v-model="showDialog"
      max-width="1000"
      persistent
    >
      <div
        v-if="selectedRental"
        class="relative mx-auto bg-white px-4 pt-5 pb-4"
      >
        <i
          @click="closeShowDialog(selectedRental)"
          class="cursor-pointer absolute top-5 right-4 z-10 bg-white p-2 text-gray-700 fas fa-window-close"
        ></i>
        <!-- cycle delimiter-icon="mdi-minus" -->
        <v-carousel hide-delimiter-background :hide-delimiters="false">
          <v-carousel-item
            v-for="(image, index) in selectedRental.Images"
            :key="index"
            :src="image"
            reverse-transition="fade-transition"
            transition="fade-transition"
          ></v-carousel-item>
        </v-carousel>
        <br />

        <div class="font-weight-light grey--text title mb-2">
          <div
            class="float-right text-xl sm:text-3xl font-medium text-gray-600"
          >
            ${{
              parseFloat(selectedRental.ListPrice)
                .toLocaleString()
                .replace(".", ",")
            }}
          </div>

          <h3 class="text-xl sm:text-3xl font-weight-light blue--text">
            {{ selectedRental.StreetNumber }}
            {{ selectedRental.StreetName }}
            {{ selectedRental.StreetSuffix }}
            {{ selectedRental.City }}, {{ selectedRental.StateOrProvince }}
            {{ selectedRental.PostalCode }}
          </h3>
        </div>

        <v-divider></v-divider>
        <div class="mt-2 mb-2 text-center">
          <v-chip class="m-1">
            <b class="mr-1"> Architecture: </b
            >{{ selectedRental.ArchitecturalStyle }}
          </v-chip>
          <v-chip class="m-1">
            <b class="mr-1">Electric Source </b
            >{{ selectedRental.ElectricSource }}
          </v-chip>
          <v-chip class="m-1">
            <b class="mr-1">Lot size: </b>{{ selectedRental.LivingAreaRange }}
          </v-chip>
          <v-chip class="m-1">
            <b class="mr-1">Bathroom: </b
            >{{ selectedRental.BathroomsTotalInteger }}</v-chip
          >
          <v-chip class="m-1">
            <b class="mr-1">Days On Market: </b
            >{{ selectedRental.DaysOnMarket }}</v-chip
          >
          <v-chip class="m-1">
            <b class="mr-1">Bedroom: </b>{{ selectedRental.BedroomsTotal }}
          </v-chip>
          <v-chip class="m-1">
            <b class="mr-1">Rooms Total: </b>{{ selectedRental.RoomsTotal }}
          </v-chip>
          <v-chip class="m-1">
            <b class="mr-1">Sewer: </b>{{ selectedRental.Sewer }}
          </v-chip>
          <v-chip class="m-1">
            <b class="mr-1">Year Built: </b> {{ selectedRental.YearBuilt }}
          </v-chip>
        </div>
        <v-divider></v-divider>

        <div v-if="!userAuth">
          <div class="relative bg-gray-900 rounded-md">
            <div
              class="max-w-4xl mx-auto px-4 sm:px-6 lg:max-w-7xl lg:px-8 xl:grid xl:grid-cols-1 xl:grid-flow-col-dense xl:gap-x-8"
            >
              <div class="relative xl:col-start-1 py-4">
                <h2
                  class="text-center text-sm font-semibold text-indigo-300 tracking-wide uppercase"
                >
                  <v-btn
                    @click="isBuyer()"
                    class="profile-card__button button--blue text-center"
                    dark
                    ><i class="fas fa-user mr-1"></i> Create Your Free Account
                  </v-btn>
                </h2>
                <p class="mt-3 text-3xl font-extrabold text-white">
                  Get started with the the buying process that makes your life
                  easy!
                </p>
                <p class="mt-5 text-lg text-gray-300">
                  360 Real Estate leverages our technology to give you the best
                  buying experience. See how our immersive home buyer experience
                  is changing the standards for Real Estate
                </p>
                <div
                  class="mt-12 grid grid-cols-1 gap-y-12 gap-x-6 sm:grid-cols-2"
                >
                  <p>
                    <span class="block text-2xl font-bold text-white"
                      >Find a Home</span
                    >
                    <span class="mt-1 block text-base text-gray-300">
                      Search the entire MLS for our area of expertise.</span
                    >
                  </p>

                  <p>
                    <span class="block text-2xl font-bold text-white"
                      >Search History</span
                    >
                    <span class="mt-1 block text-base text-gray-300"
                      >Automated features make organizing your homes a
                      breeze</span
                    >
                  </p>

                  <p>
                    <span class="block text-2xl font-bold text-white"
                      >Side by Side Comparisons</span
                    >
                    <span class="mt-1 block text-base text-gray-300"
                      >Proprietary technology comparing homes side by side</span
                    >
                  </p>

                  <p>
                    <span class="block text-2xl font-bold text-white"
                      >Digital Documents</span
                    >
                    <span class="mt-1 block text-base text-gray-300"
                      >Submitting offers faster gets your in FIRST!</span
                    >
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-else class="sm:mt-3  profile-card-ctr text-center">
          <a
            :href="
              'https://www.homesby360.com/single/' +
                selectedRental.ListingKeyNumeric
            "
            target="_blank"
            class="profile-card__button button--blue text-center text-white"
            ><i class="fas fa-home"></i> View Details
          </a>
        </div>
      </div>

      <div v-else class="bg-white">
        <div class="mx-auto grid gap-4 lg:grid-cols-2">
          <div v-if="user" class="p-2 bg-gray-50">
            <v-alert
              v-if="!checkSigned"
              class="sm:mt-6"
              border="top"
              colored-border
              type="info"
              elevation="2"
            >
              <template v-if="user.trackers.length > 0">
                <span v-if="showMessage" class="text-sm text-gray-500"
                  >Please sign the <b>DISCLOSURE</b> and <b>AGENCY</b> documents
                  to be able to request a visit <br />
                  <v-btn x-small @click="goDashboard" color="info">
                    Complete Paperwork
                  </v-btn>
                </span>
                <span v-else class="text-sm text-gray-500"
                  >Please check the status of these documents <b>(SIGNED)</b> to
                  be able to request a visit.
                </span>
                <div class="sm:mt-1 sm:flex sm:gap-2">
                  <div v-for="track in trackedSub" :key="track.id" class="">
                    <div v-if="track.status == 'signed'">
                      <v-btn
                        x-small
                        @click="
                          openClient(
                            (client = user),
                            track.submission,
                            track.id
                          )
                        "
                        color="success"
                      >
                        {{ track.menu_name }} Document Signed</v-btn
                      >
                    </div>
                    <div v-else-if="track.status == 'email_sent'">
                      <v-btn
                        x-small
                        @click="
                          openClient(
                            (client = user),
                            track.submission,
                            track.id
                          )
                        "
                        color="warning"
                      >
                        {{ track.menu_name }}: Check your email</v-btn
                      >
                    </div>
                    <div v-else>
                      <v-btn
                        x-small
                        @click="
                          openClient(
                            (client = user),
                            track.submission,
                            track.id
                          )
                        "
                        color="info"
                      >
                        {{ track.menu_name }} Document Pending...
                      </v-btn>
                    </div>
                  </div>
                  <!-- <small class="font-bold"> Document {{track.menu_name}}: </small>
                                        <span  class="mt-1 cursor-pointer inline-flex text-xs px-2.5 py-0.5 rounded-full text-xs font-medium bg-pink-100 text-pink-600">
                                            {{track.status.replace('_', ' ')}} <i class="fas fa-signature ml-1"></i>
                                        </span> -->
                </div>
              </template>

              <template v-else>
                <span class="text-sm text-gray-500"
                  >Please sign the <b>DISCLOSURE</b> and <b>AGENCY</b> documents
                  to be able to request a visit.
                </span>
                <v-btn x-small @click="goDashboard" color="info">
                  Complete Paperwork
                </v-btn>
              </template>
            </v-alert>

            <!-- <span class="text-sm text-gray-500">Please sign the <b>DISCLOSURE</b> and <b>AGENCY</b> documents to be able to request a visit</span> -->
          </div>

          <div v-if="user" class="p-2 bg-gray-50">
            <div v-if="user.lenders.length < 1">
              <lender :user="user" :styleGrid="true"></lender>
            </div>
          </div>
          <v-btn
            class="mt-4 bg-gray-200 lg:col-span-2 text-right"
            color="secondary"
            text
            @click="closeDialogModal"
          >
            <i class="far fa-times-circle"></i> close
          </v-btn>
        </div>
      </div>
    </v-dialog>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import Swal from "sweetalert2";
import Lender from "../Clients/ContentDisplays/Lender.vue";
export default {
  components: { Lender },
  props: ["rental", "isFirm", "isSearch", "isFav", "isShown", "markShown"],
  data() {
    return {
      showDialog: false,
      trackedSub: [],

      selectedRental: "",
      disabledButton: false,
      showMessage: false,
      valueLoading: false,
      canceling: false
    };
  },

  computed: {
    ...mapGetters({
      user: "userLogin",
      userAuth: "userAuth"
    }),

    checkDisclosure() {
      return this.user.trackers.some(track => {
        if (track.menu_name == "Disclosure") {
          if (track.status == "signed") {
            return true;
          } else {
            return false;
          }
        }
      });
    },

    checkAgency() {
      return this.user.trackers.some(track => {
        if (track.menu_name == "Agency") {
          if (track.status == "signed") {
            return true;
          } else {
            return false;
          }
        }
      });
    },

    checkSigned() {
      if (this.checkDisclosure && this.checkAgency) {
        return true;
      } else {
        return false;
      }
    }
  },

  methods: {
    markShownHome() {
      this.$emit("marked");
    },

    cancelRequested() {
      this.$emit("canceled");
    },

    submitOffer(fav) {
      this.disabledButton = true;
      window.axios
        .post("api/submitOTP/" + fav.id, {
          userId: this.user.id
        })
        .then(() => {
          this.$store.dispatch("getUser");
          Swal.fire({
            position: "top-end",
            icon: "success",
            title:
              "Offer successfully generated. You can review it from your profile's paper work",
            showConfirmButton: false,
            timer: 4000
          });
          this.disabledButton = false;
        });
    },

    isBuyer() {
      this.$router.push({
        name: "BuyerRegister",
        params: { state: "Buyer" }
      });
    },

    singleView(rental) {
      this.$router.push({
        name: "SingleIDX",
        params: { id: rental.ListingKeyNumeric }
      });
    },

    containUser(user, listing) {
      if (this.userAuth) {
        let value = user.searches.filter(
          value => value.listingId === listing.ListingKeyNumeric
        );
        if (value.length > 0) {
          if (value[0].favorite == "1") {
            return true;
          }
        } else {
          return false;
        }
      } else {
        return false;
      }
    },

    haveUser(user, listing) {
      if (this.userAuth) {
        let value = user.searches.filter(
          value => value.listingId === listing.listingId
        );
        if (value.length > 0) {
          if (value[0].favorite == "1") {
            return true;
          }
        } else {
          return false;
        }
      } else {
        return false;
      }
    },

    unMarkFavorite(listing) {
      window.axios
        .get("api/unMarkFavorite/" + listing.ListingKeyNumeric)
        .then(() => {
          this.$store.dispatch("getUser");
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Succesfully unfavorite",
            showConfirmButton: false,
            timer: 1500
          });
        });
    },

    unMarked(listing) {
      window.axios.get("api/unMarkFavorite/" + listing.listingId).then(() => {
        this.$store.dispatch("getUser");
        Swal.fire({
          position: "top-end",
          icon: "success",
          title: "Succesfully unfavorite",
          showConfirmButton: false,
          timer: 1500
        });
      });
    },

    markFavorite(listing) {
      window.axios
        .get("api/markFavorite/" + listing.ListingKeyNumeric)
        .then(() => {
          this.$store.dispatch("getUser");
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Succesfully marked as favorite",
            showConfirmButton: false,
            timer: 1500
          });
        });
    },

    redirectListing(listing) {
      this.$router.push({ name: "SingleIDX", params: { id: listing } });
    },

    checkFavorite(listing) {
      window.axios.get("api/markFavorite/" + listing).then(() => {
        this.$store.dispatch("getUser");
        Swal.fire({
          position: "top-end",
          icon: "success",
          title: "Successfully moved to Favorites",
          showConfirmButton: false,
          timer: 1500
        });
      });
    },

    cancelShowing(fav) {
      this.canceling = true;
      window.axios.post("api/cancelShowing/" + fav.id).then(() => {
        this.$store.dispatch("getUser");
        this.canceling = false;
      });
    },

    requestShowing(fav) {
      //@todo reformatting using the function for check the doc status

      if ((this.user.trackers.length > 1) & (this.user.lenders.length > 0)) {
        this.showMessage = false;
        //   if(track.menu_name == 'Disclosure' || track.menu_name == 'Agency'){
        //   if(track.status.includes('signed') ){
        if (this.checkSigned) {
          this.valueLoading = true;
          window.axios.get("api/requestShowing/" + fav.id).then(() => {
            this.valueLoading = false;
            this.$store.dispatch("getUser");
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Request succesfully sent!",
              showConfirmButton: false,
              timer: 1500
            });
          });
        } else {
          this.user.trackers.forEach(track => {
            this.trackedSub.push(track);
            this.showDialog = true;
          });
        }
        //   }
      } else if (
        (this.user.trackers.length == 1) &
        (this.user.lenders.length > 0)
      ) {
        this.showDialog = true;
        this.showMessage = true;

        //  window.axios.get("api/requestShowing/" + fav.id).then(() => {
        //     this.$store.dispatch("getUser");
        //   });
      } else {
        this.showDialog = true;
        this.showMessage = true;
      }
    },

    closeDialogModal() {
      this.showDialog = false;
      this.trackedSub = [];
    },

    closeShowDialog(listing) {
      this.showDialog = false;
      this.trackedSub = [];

      if (this.userAuth) {
        window.axios
          .post("api/createSearch/" + listing.ListingKeyNumeric, {
            address:
              listing.StreetNumber +
              " " +
              listing.StreetName +
              " " +
              listing.StreetSuffix,
            imageUrl: listing.Images[0],
            price: listing.ListPrice,
            squaref: listing.LotSizeAcresRange,
            market: listing.DaysOnMarket,
            bath: listing.BathroomsFull,
            bed: listing.BedroomsTotal,
            allImages: listing.Images
          })
          .then(res => {
            this.$store.dispatch("getUser");
            if (res.data == "Created") {
              this.$emit("update");
            }
          });
      }
    },

    openClient(client, sub, track) {
      this.$router.push({
        name: "Dashboard",
        params: { user: client, submission: sub, trackId: track }
      });
    },

    goDashboard() {
      this.$router.push({ name: "Dashboard", params: { openDocs: true } });
    },

    showHouse(rental) {
      this.selectedRental = rental;
      this.showDialog = true;
    }
  }
};
</script>
